import React from "react";
import { PopupButton } from "react-calendly";

const AppointButton = ({ text }) => {
  return (
    <>
      <PopupButton
        url="https://calendly.com/connect-360fintax/30min"
        rootElement={document.getElementById("root")}
        text={text}
        textColor="#ffffff"
        color="#00a2ff"
      />
    </>
  );
};

export default AppointButton;
